import { cn } from '@/shadcn-ui/utils';
import { colors } from '@/theme/colors';
import { SvgIconCommonProps } from './types/svg-icon-common-props';

export default function ChevronUpThick({
  className,
  fillPrimary = colors.neutral60,
}: SvgIconCommonProps) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('h-[24px] w-[24px]', className)}
    >
      <path
        d="M4.33834 14.0401L11.0428 7.4212C11.3218 7.1404 11.6424 7 12.0045 7C12.1885 7 12.3576 7.03725 12.512 7.11175C12.6722 7.18052 12.8236 7.28367 12.9661 7.4212L19.6528 14.0401C19.8843 14.2521 20 14.5186 20 14.8395C20 15.0573 19.9466 15.255 19.8397 15.4327C19.7329 15.6046 19.5875 15.7421 19.4034 15.8453C19.2254 15.9484 19.0265 16 18.8069 16C18.4626 16 18.1718 15.8825 17.9343 15.6476L11.6038 9.3639H12.414L6.06567 15.6476C5.82823 15.8825 5.53738 16 5.1931 16C4.97347 16 4.77166 15.9484 4.58765 15.8453C4.40957 15.7421 4.26711 15.6046 4.16027 15.4327C4.05342 15.255 4 15.0573 4 14.8395C4 14.6848 4.02671 14.5387 4.08013 14.4011C4.13949 14.2636 4.22556 14.1433 4.33834 14.0401Z"
        fill={fillPrimary}
      />
    </svg>
  );
}
